const getGlobalConfigValue = (globalConfig, camelKey, upperKey) => {
  return globalConfig?.[camelKey] || globalConfig?.[upperKey] || '';
};

export const resolveAccountBrandingLogo = ({
  branding = {},
  globalConfig = {},
  isDark = false,
}) => {
  const customLightLogo = branding.logo_thumbnail || '';
  const customDarkLogo = branding.logo_thumbnail_dark || '';
  const globalLightLogo = getGlobalConfigValue(
    globalConfig,
    'logoThumbnail',
    'LOGO_THUMBNAIL'
  );
  const globalDarkLogo = getGlobalConfigValue(
    globalConfig,
    'logoDark',
    'LOGO_DARK'
  );

  if (isDark) {
    return (
      customDarkLogo ||
      customLightLogo ||
      globalDarkLogo ||
      globalLightLogo ||
      ''
    );
  }

  return (
    customLightLogo || globalLightLogo || customDarkLogo || globalDarkLogo || ''
  );
};

export const resolveAccountBrandingLoginPath = ({
  branding = {},
  fallback = '/app/login',
}) => {
  const loginSlug = branding.login_slug || '';

  if (!loginSlug) return fallback;

  return `/app/login?account=${encodeURIComponent(loginSlug)}`;
};
